module.exports = __webpack_public_path__ + "media/images/partners/derzkino-93e980a282635a150f2dc211ab66ee77.png";